import React from 'react';
import { useTaxForm } from './TaxFormContext';

const steps = [
  { id: 1, title: 'Identity & Prefs', urdu: 'شناخت اور ترجیحات' },
  { id: 2, title: 'Incomes & WHT', urdu: 'آمدنی اور کٹوتیاں' },
  { id: 3, title: 'Personal Expenses', urdu: 'ذاتی اخراجات' },
  { id: 4, title: 'Wealth Declaration', urdu: 'کل اثاثہ جات' },
  { id: 5, title: 'Liabilities', urdu: 'مالی واجبات' },
  { id: 6, title: 'Review & Sign-off', urdu: 'حتمی جائزہ' },
];

export const MobileStepProgress: React.FC = () => {
  const { currentStep } = useTaxForm();
  
  const currentStepData = steps.find(s => s.id === currentStep) || steps[0];

  return (
    <div className="w-full px-5 pt-5 pb-3">
      {/* Segmented Progress Pills */}
      <div className="flex gap-1.5 mb-4">
        {steps.map((step) => {
          const isCompleted = step.id < currentStep;
          const isCurrent = step.id === currentStep;
          
          return (
            <div 
              key={step.id} 
              className="h-1.5 flex-1 rounded-full overflow-hidden bg-slate-200/50 backdrop-blur-sm relative"
            >
              {/* Fill */}
              <div 
                className={`absolute inset-0 rounded-full transition-all duration-500 ease-out ${
                  isCompleted ? 'bg-primary' : isCurrent ? 'bg-primary w-full origin-left animate-[progress_2s_ease-out]' : 'w-0'
                }`}
              />
            </div>
          );
        })}
      </div>

      <div className="flex justify-between items-end px-1">
        <div>
          <p className="text-[10px] text-primary/80 font-bold uppercase tracking-widest mb-1">
            Step {currentStep} of {steps.length}
          </p>
          <h2 className="text-2xl font-black text-slate-800 tracking-tight leading-none">
            {currentStepData.title}
          </h2>
        </div>
        <div className="text-right">
          <p className="text-[10px] text-primary/80 font-urdu mb-1 opacity-80">
            مرحلہ {currentStep}
          </p>
          <h2 className="text-lg font-urdu font-bold text-slate-800 leading-none">
            {currentStepData.urdu}
          </h2>
        </div>
      </div>
    </div>
  );
};
